import {
  filterLocales,
  formatLocales,
  getEnabledLocales,
  Locale,
  sortLocales,
} from '@vimond/utils/locales/localeUtils';
import { SupportedLanguage } from '../locales';

const getDefaultLanguage = async (): Promise<SupportedLanguage> => {
  return await getLocales().then(
    (locales) => locales.find((locale) => locale.default)?.locale ?? 'en',
  );
};

// cache the locales since the list is static and the same for all users
let localesCache: Locale[] = [];

const getLocales = async (): Promise<Locale[]> => {
  if (localesCache.length > 0) {
    return localesCache;
  }

  const enabledLocales = getEnabledLocales();

  try {
    const localesFromApi = await fetchLocales();
    const filteredLocales = filterLocales(localesFromApi, enabledLocales);
    const sortedLocales = sortLocales(filteredLocales);
    localesCache = formatLocales(sortedLocales);
    return localesCache;
  } catch (error) {
    console.error('Error getting locales: ', error);
    return [];
  }

  async function fetchLocales(): Promise<Locale[]> {
    const headers = {
      accept: 'application/json',
    };
    const requestOptions: RequestInit = {
      method: 'GET',
      headers,
      redirect: 'follow',
      cache: 'force-cache',
    };
    const response = await fetch(`/api/locales`, requestOptions);
    return (await response.json()) as unknown as Locale[];
  }
};

export { getDefaultLanguage, getLocales };
export type { Locale };
